import { ISession } from '../../models/session';
import { Injectable } from '@angular/core';
import { Response, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { isEmpty, isNil, contains } from 'ramda/es';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ShortUrlService extends BasicService {
  private SHORT_API = config.short.url;

  constructor(protected auth: AuthService, protected translate: TranslateService, private http: AuthHttp) {
    super(auth, translate);
  }

  private onError(error) {
    // this is not the best solution, but we don't want to update our shortener server for EVA v0.1
    if (contains('This link is already taken', error._body)) {
      toastr.error(this.translate.instant('sessions.edit.link.taken'));
    }
    return Observable.throw(error);
  }

  public get(id: string, notify: boolean = false) {
    if (!id) {
      return Observable.of(false);
    }
    return this.http.get(`${this.SHORT_API}/links/${id}`).map(res => this.extractData(res, notify));
  }

  public add(payload: any, notify: boolean = false) {
    return this.http
      .post(`${this.SHORT_API}/links`, payload)
      .map(res => {
        return this.extractData(res, notify);
      })
      .catch(err => this.onError(err));
  }

  public update(id: string, payload: any, notify: boolean = false) {
    if (isEmpty(payload.from) || isNil(payload.from[0]) || isEmpty(payload.from[0])) {
      return Observable.of(false);
    }
    if (!id) {
      return this.add(payload);
    }
    return this.http.put(`${this.SHORT_API}/links/${id}`, payload).map(res => this.extractData(res, notify));
  }

  public delete(id: string, notify: boolean = false) {
    if (!id) {
      return Observable.of(false);
    }
    return this.http.delete(`${this.SHORT_API}/links/${id}`).map(res => this.extractData(res, notify));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/shorturl.service.ts